<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { merge } from "lodash";
import "svelte/transition";
import { onMount, tick } from "svelte";
import { BaseAtom } from "components/cards/atoms";
import { PageParticle, } from "components/cards/particles/YinzCam";
import { ImageParticle, TextParticle, ButtonParticle, SearchParticle } from "components/cards/particles/YinzCam";
export let container;
export let backgroundColor;
export let logoButton;
export let teamButtons;
export let navigationLink;
export let hamburgerButton;
export let loginButton;
export let tabletLoginButton;
export let profileButton;
export let hamburgerMenuPage;
export let dropdownIcon;
export let dropdownHeading;
export let dropdownLink;
export let searchButton;
export let searchBar;
export let items = [];
let isModalOpen = false;
let isLoaded = false;
let isTeamDropdownOpen = false;
let isDropdownOpen = false;
let isSearchBarOpen = false;
let isHamburgerOpen = false;
let removeNavBorderRadius = false;
let activeSubsection = undefined;
onMount(() => {
    if (hamburgerMenuPage === null || hamburgerMenuPage === void 0 ? void 0 : hamburgerMenuPage.slug) {
        tick().then(() => {
            isLoaded = true;
        });
    }
});
const toggleTeamDropdown = () => {
    if (isTeamDropdownOpen) {
        isTeamDropdownOpen = false;
        setTimeout(() => {
            removeNavBorderRadius = false;
        }, 400);
    }
    else {
        isTeamDropdownOpen = true;
        isDropdownOpen = false;
        isSearchBarOpen = false;
        removeNavBorderRadius = true;
    }
};
const openDropdown = (subsection) => {
    activeSubsection = subsection;
    isDropdownOpen = true;
    isSearchBarOpen = false;
    if (isTeamDropdownOpen) {
        isTeamDropdownOpen = false;
        setTimeout(() => {
            removeNavBorderRadius = false;
        }, 400);
    }
};
const toggleSearchBar = () => {
    if (isSearchBarOpen) {
        isSearchBarOpen = false;
    }
    else {
        isDropdownOpen = false;
        isTeamDropdownOpen = false;
        isSearchBarOpen = true;
    }
};
const toggleHamburgerMenu = () => {
    if (isHamburgerOpen) {
        isHamburgerOpen = false;
    }
    else {
        isHamburgerOpen = true;
        isDropdownOpen = false;
        isTeamDropdownOpen = false;
        isSearchBarOpen = false;
    }
};
</script>

<BaseAtom _isotope="NavigationMenuD" {...container}>
  <nav
    class="navbar"
    style="--nav-background: {backgroundColor};"
    class:team-open={removeNavBorderRadius}
    on:mouseleave={() => (isDropdownOpen = false)}
  >
    <div class="nav-top-row">
      <div class="nav-brand">
        <ButtonParticle {...logoButton} on:click={toggleTeamDropdown} />
      </div>
      <div class="nav-links">
        {#if items}
          {#each items as navItem}
            {#if !navItem.subsections}
              <ButtonParticle
                {...merge({}, navigationLink, {
                  link: navItem.linkUrl,
                  text: { text: navItem.title },
                })}
              />
            {:else}
              <div class="nav-dropdown-toggle">
                <ButtonParticle
                  {...merge({}, navigationLink, {
                    link: navItem.linkUrl,
                    text: { text: navItem.title },
                  })}
                  on:mouseenter={() => openDropdown(navItem.subsections)}
                />
                <div class="dropdown-icon">
                  <ImageParticle {...dropdownIcon} />
                </div>
              </div>
            {/if}
          {/each}
        {/if}
      </div>
      <div class="nav-actions">
        <ButtonParticle {...searchButton} on:click={toggleSearchBar} />
        <div class="divider"></div>
        <div class="desktop-button">
          <ButtonParticle {...loginButton} />
        </div>
        <div class="tablet-button">
          <ButtonParticle {...tabletLoginButton} />
        </div>
      </div>
      <div class="hamburger-button">
        <ButtonParticle {...hamburgerButton} on:click={toggleHamburgerMenu} />
      </div>
    </div>
    <div class="hamburger-menu" class:open={isHamburgerOpen}>
      <div class="hamburger-menu-inner">
        {#if hamburgerMenuPage && isLoaded}
          <PageParticle {...hamburgerMenuPage}/>
        {/if}
      </div>
    </div>
    <div class="search-bar-wrapper" class:open={isSearchBarOpen}>
      <div class="search-bar-inner">
        <SearchParticle {...searchBar} />
      </div>
    </div>
    <div class="team-dropdown" class:open={isTeamDropdownOpen}>
      {#if teamButtons}
        {#each teamButtons as teamButton}
          <ButtonParticle {...teamButton} />
        {/each}
      {/if}
    </div>
    <div class="mega-menu-wrapper" class:open={isDropdownOpen}>
      <div class="mega-menu-inner">
        <div class="mega-sidebar">
          {#if teamButtons}
            {#each teamButtons as teamButton}
              <ButtonParticle {...teamButton} />
            {/each}
          {/if}
        </div>
        <div class="mega-content">
          {#if activeSubsection}
            {#each activeSubsection as subsection}
              <div class="links-container">
                <TextParticle
                  {...merge({}, dropdownHeading, {
                    text: subsection.title,
                  })}
                />
                {#each subsection.pages as link}
                  <ButtonParticle
                    {...merge({}, dropdownLink, {
                      link: link.linkUrl,
                      text: { text: link.title },
                    })}
                  />
                {/each}
              </div>
            {/each}
          {/if}
        </div>
      </div>
    </div>
  </nav>
</BaseAtom>

<style>
  .navbar {
    position: absolute;
    top: 34px;
    left: 50%;
    transform: translateX(-50%);
    width: 92%;
    background-color: var(--nav-background);
    border-radius: 12px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
  }

  .navbar.team-open {
    border-bottom-left-radius: 0;
  }

  .nav-top-row {
    display: flex;
    align-items: center;
    height: 80px;
    padding: 0 15px;
  }

  .nav-brand {
    margin-right: 2.1rem;
  }

  .nav-links {
    display: flex;
    margin: 0;
    padding: 0;
    flex-grow: 1;
    gap: 25px;
  }

  .nav-actions {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .team-dropdown {
    position: absolute;
    top: 80px;
    left: 0px;
    width: 84px;
    background-color: var(--nav-background);
    border-radius: 0 0 12px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25px;
    padding: 0;
    max-height: 0;
    overflow: hidden;
    transition:
      max-height 0.4s ease-in-out, padding 0.4s ease-in-out;
    z-index: 999;
  }

  .team-dropdown.open {
    max-height: 600px;
    padding: 20px 0;
  }

  .nav-dropdown-toggle {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .divider {
    width: 1px;
    height: 32px;
    background-color: white;
  }

  .mega-menu-wrapper,
  .search-bar-wrapper,
  .hamburger-menu {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.4s ease-in-out;
    background-color: var(--nav-background);
    border-radius: 0 0 12px 12px;
    overflow: hidden;
  }

  .mega-menu-wrapper.open,
  .search-bar-wrapper.open {
    grid-template-rows: 1fr;
  }

  .search-bar-inner,
  .hamburger-menu-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    min-height: 0;
    overflow: hidden;
  }

  .hamburger-menu-inner {
    flex-direction: column;
    align-items: stretch;
    padding: 0;
  }

  .mega-menu-inner {
    overflow: hidden;
    display: flex;
  }

  .mega-sidebar {
    width: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    gap: 25px;
  }

  .mega-content {
    padding: 13px;
    position: relative;
  }

  .links-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .tablet-button,
  .hamburger-button,
  .hamburger-menu {
    display: none;
  }

  @media (max-width: 1200px) {
    .desktop-button {
      display: none;
    }

    .tablet-button {
      display: block;
    }
  }

  @media (max-width: 1000px) {
    .nav-actions,
    .nav-links {
      display: none;
    }

    .hamburger-button {
      display: block;
    }

    .nav-top-row {
      justify-content: space-between;
      height: 62px;
    }

    .team-dropdown {
      top: 62px;
    }

    .hamburger-menu {
      display: grid;
    }

    .hamburger-menu.open {
      grid-template-rows: 1fr;
    }
  }</style>
